import { Pipe, PipeTransform } from '@angular/core';
import { DataListItem } from '../pa-data-list/models/pa-data-list.model';
import { PaTableColumn, PaTableData } from './models/pa-table.model';
import { mapRowToDataListItemsUtil } from './utils/pa-table-data-list.util';

@Pipe({
  name: 'paTableRowToDataList',
  standalone: true,
})
export class PaTableRowToDataListPipe implements PipeTransform {
  transform(item: PaTableData, columns: PaTableColumn[]): DataListItem[] {
    return mapRowToDataListItemsUtil(item, columns);
  }
}
